import { fetchWrapper } from "../../../fetchWrapper";

// Listar nodos con paginación
export const NodeListService = async (page, pageSize) => {
  try {
    const result = await fetchWrapper(
      `${process.env.REACT_APP_BACKEND_URL}/nodes/?page=${page}&pageSize=${pageSize}`,
      { method: "GET" }
    );
    if (result.success) {
      return result;
    } else {
      const errorMessage = result.message || "Error del servidor al realizar la solicitud";
      throw new Error(errorMessage);
    }
  } catch (error) {
    return { success: false, message: error.message };
  }
};

// Listar todos los nodos sin requerir permisos
export const NodeListAllService = async () => {
  try {
    const result = await fetchWrapper(
      `${process.env.REACT_APP_BACKEND_URL}/nodes/all/`,
      { method: "GET" }
    );
    
    // Si result.success existe, significa que hubo un error
    if (result.success === false) {
      return result;
    }
    
    // Si no hay success, significa que result es directamente el array de datos
    return {
      success: true,
      payload: result // result es directamente el array de nodos
    };
  } catch (error) {
    return { success: false, message: error.message };
  }
};

// Obtener nodo por ID
export const NodeByIDService = async (id) => {
  try {
    const result = await fetchWrapper(`${process.env.REACT_APP_BACKEND_URL}/nodes/${id}/`, {
      method: "GET",
    });
    return result;
  } catch (error) {
    return { success: false, message: error.message };
  }
};

// Crear nodo
export const NodeCreateService = async (payload) => {
  try {
    const result = await fetchWrapper(`${process.env.REACT_APP_BACKEND_URL}/nodes/create/`, {
      method: "POST",
      body: JSON.stringify(payload),
    });
    return result;
  } catch (error) {
    return {
      success: false,
      message: error.message || "Error del servidor al realizar la solicitud",
    };
  }
};

export const NodeUpdateService = async (id, payload) => {
  try {
    const result = await fetchWrapper(`${process.env.REACT_APP_BACKEND_URL}/nodes/${id}/update/`, {
      method: "PUT",
      body: JSON.stringify(payload),
    });
    return result;
  } catch (error) {
    return {
      success: false,
      message: error.message || "Error del servidor al realizar la solicitud",
    };
  }
};

export const NodeDeleteService = async (id) => {
  try {
    const result = await fetchWrapper(`${process.env.REACT_APP_BACKEND_URL}/nodes/${id}/delete/`, {
      method: "DELETE",
    });
    return result;
  } catch (error) {
    return {
      success: false,
      message: error.message || "Error del servidor al realizar la solicitud",
    };
  }
};
